import { Box, Divider, Grid, Typography } from "@material-ui/core";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "1em",
    backgroundColor: "#E8F3F8", // Light blue background
    padding: theme.spacing(2),
    borderRadius: "4px",
    display: "flex", // Use flexbox for the root
    alignItems: "stretch", // Vertically center content
  },
  header: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#000",
  },

  divider: {
    backgroundColor: "#B0BEC5",
    height: "100%",
    width: "2px",
    margin: theme.spacing(0, 2),
  },
  rightAlign: {
    textAlign: "right",
  },
}));

export default function Ribbon({ selectedRowData, batch }) {
//console.log('selectedRowData ribbon:', selectedRowData);
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Grid container spacing={3}>
        <Grid item>
          <Typography className={classes.header}>BMS name</Typography>
          <Typography variant="body2">
            {selectedRowData?.sponsorName}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>CMO</Typography>
          <Typography variant="body2">{selectedRowData?.vendorName}</Typography>
        </Grid>
        <Grid item>
          <Typography className={classes?.header}>
            Product code / description
          </Typography>
          <Typography variant="body2">
            {selectedRowData?.productCode} / {selectedRowData?.productName}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes?.header}>PO quantity</Typography>
          <Typography variant="body2">
            {selectedRowData?.targetQuantity}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>UoM</Typography>
          <Typography variant="body2">
            {selectedRowData?.targetQuantityUOM}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>PO - line</Typography>
          <Typography variant="body2">{selectedRowData?.poNumber}-{selectedRowData?.poLineItemNumber
          }</Typography>
        </Grid>

        <Grid item>
          <Box className={classes.divider} />
        </Grid>

        <Grid item>
          <Typography className={classes.header}>Batch number</Typography>
          <Typography variant="body2">{batch?.vendorBatchNumber}</Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>Batch size</Typography>
          <Typography variant="body2">
            {batch?.batchSize}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.header}>UoM</Typography>
          <Typography variant="body2">{batch?.batchUOM}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
